import React, { FC, ReactElement } from 'react'
import styles from './SnsResolve.module.css'
import classNames from 'classnames'
import copy from 'copy-to-clipboard'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'
import useInscriptionModal from '@/utils/hooks/useInscriptionModal'

const SnsResolve: FC<{ sns: any; error: boolean }> = (props): ReactElement => {
	const { sns } = props
	const openInscriptionModal = useInscriptionModal()

	const [open, setOpen] = React.useState(false)
	const _handleClose = React.useCallback(() => setOpen(false), [])

	const handleCopy = (evt: any) => {
		evt.preventDefault()
		evt.stopPropagation()

		setOpen(true)
		copy(sns?.address)
		setTimeout(() => setOpen(false), 1500)
	}

	if (props.error) {
		return (
			<div className={styles.root}>
				<p className={classNames(styles.error, 'text-sm', 'regular')}>Error resolving name</p>
			</div>
		)
	}

	if (!sns) {
		return <React.Fragment />
	}

	return (
		<div className={styles.root}>
			{!open && (
				<p
					className={classNames(styles.address, 'text-sm', 'regular')}
					onClick={handleCopy}
					role="button"
					tabIndex={0}
					onKeyDown={onKeyboardClick(handleCopy)}
				>
					{sns?.address?.slice(0, 5)}...{sns?.address.slice(-5)}
				</p>
			)}
			{open && <p className={classNames(styles.address, 'text-sm', 'regular')}>Copied</p>}
				<button
					type="button"
					onClick={() => {
						if (sns?.inscription_id) openInscriptionModal({ id: sns.inscription_id })
					}}
					className={classNames(styles.num, 'text-sm', 'regular')}
				>
					Inscription #{sns?.inscription_num}
				</button>
		</div>
	)
}

export default SnsResolve
